import React, { useEffect } from "react";
import { Spinner } from "reactstrap";
import useCustomMutation from "../../Hooks/useCustomMutation";
import { dangerMessage } from "../../components/Toast/Toast";

const DeleteFaqForm = ({ faqID, token, eventID, setIsToggleDelete }) => {
  // Invalidate the same query that loads eventDetails in EventSetUp
  // EventSetUp uses key ["myEventDetail", eventID]
  const key = eventID ? ["myEventDetail", eventID] : ["myEventDetail"];
  const mutation = useCustomMutation(key);

  const deleteFaq = () => {
    // Validate required fields
    if (!faqID) {
      dangerMessage("FAQ ID is missing. Cannot delete.");
      console.error("DeleteFaqForm: faqID is missing", { faqID, eventID, token });
      return;
    }

    if (!token) {
      dangerMessage("Authentication token is missing. Please log in again.");
      console.error("DeleteFaqForm: token is missing", { faqID, eventID });
      return;
    }

    if (!eventID) {
      dangerMessage("Event ID is missing. Cannot delete FAQ.");
      console.error("DeleteFaqForm: eventID is missing", { faqID, eventID, token });
      return;
    }

    console.log("DeleteFaqForm: Attempting to delete FAQ", { faqID, eventID, url: `faq/${faqID}?eid=${eventID}` });

    const Method = "DELETE";
    const url = `faq/${faqID}?eid=${eventID}`;
    const data = {
      endPoint: url,
      bodyContent: null,
      Method: Method,
      displayMessage: "FAQ successfully deleted",
      token: token,
      isJSON: null,
    };
    
    mutation.mutate(data);
  };

  useEffect(() => {
    if (mutation?.isSuccess) {
      setIsToggleDelete(false);
    }
  }, [mutation?.isSuccess, setIsToggleDelete]);

  useEffect(() => {
    if (mutation?.isError) {
      console.error("DeleteFaqForm: Delete error", {
        error: mutation.error,
        faqID,
        eventID,
        mutationData: mutation.data
      });
      const errorMessage = mutation?.error?.response?.data?.message || 
                          mutation?.error?.message || 
                          "Failed to delete FAQ. Please try again.";
      dangerMessage(errorMessage);
    }
  }, [mutation?.isError, mutation?.error, faqID, eventID]);

  const isDisabled = mutation?.isLoading || !faqID || !token || !eventID;

  return (
    <div className="w-100">
      <h5 className="text-danger">
        Are you sure you want to delete this FAQ ?
      </h5>
      {mutation?.isError && (
        <div className="alert alert-danger mt-2" role="alert">
          <strong>Error:</strong> {mutation?.error?.response?.data?.message || mutation?.error?.message || "An error occurred while deleting the FAQ. Please try again."}
          {!eventID && <div className="mt-1"><small>Event ID is missing. Please refresh the page.</small></div>}
        </div>
      )}
      {!eventID && (
        <div className="alert alert-warning mt-2" role="alert">
          <small>Warning: Event ID is missing. This may cause issues with refreshing the FAQ list.</small>
        </div>
      )}
      <div className="modal-footer d-flex justify-content-between">
        <button
          onClick={() => {
            setIsToggleDelete(false);
          }}
          type="button"
          className="btn btn-dark"
          disabled={mutation?.isLoading}
        >
          Cancel
        </button>
        <button 
          onClick={deleteFaq} 
          type="button" 
          className="btn btn-danger"
          disabled={isDisabled}
        >
          {!mutation?.isLoading ? (
            <span className="px-2">Sure</span>
          ) : (
            <span>
              <Spinner as="span" animation="border" size="sm" />
              Loading
            </span>
          )}
        </button>
      </div>
    </div>
  );
};

export default DeleteFaqForm;
